import React from 'react';
import { View, TouchableOpacity, Image, Platform } from 'react-native';
import { Text, Button, Dialog, Portal } from 'react-native-paper';
import * as ImagePicker from 'expo-image-picker';
import * as TaskManager from "expo-task-manager";
import * as Updates from "expo-updates";
import axios from 'axios';
import RBSheet from "react-native-raw-bottom-sheet";
import AddImage from '../../assets/Add-Image.png';

export default function ImageUploader({onChange, value}){
  const [isUpload, setIsUpload] = React.useState(true);
  const [imagesArray, setImagesArray] = React.useState([]);
  const [imagesIds, setImagesIds] = React.useState([]);
  const [isPickImageError, setIsPickImageError] = React.useState(false);
  const [status, requestPermission] = ImagePicker.useMediaLibraryPermissions();

  React.useEffect(() => {
    (async () => {
      const getMediaLibraryPermissionsAsync = await ImagePicker.getMediaLibraryPermissionsAsync();
      if (getMediaLibraryPermissionsAsync.status !== 'granted') {
        await ImagePicker.requestMediaLibraryPermissionsAsync();
      }
    })();
  }, []);

  React.useEffect(() => {
    if(value && Object.keys(value).length > 0) {
      setIsUpload(false);
      let valueData = [];
      Object.values(value).map(item => {
        valueData.push({id: item.id, uri: item.url});
      })
      setImagesArray(valueData);
    }
  }, [])

  React.useEffect(() => {
    onChange(imagesIds);
  }, [imagesIds]);

  const makeId = (length) => {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }
    return result;
  }

  const pickImage = async () => {
    try {
      let result = await ImagePicker.launchImageLibraryAsync({
        mediaTypes: ImagePicker.MediaTypeOptions.Images,
        allowsMultipleSelection: true,
        quality: 1,
        base64: Platform.OS === "web" ? true : false
      });
      setIsUpload(true);
      if(result.assets) {
        Object.values(result.assets).map((item) => {
          setImagesArray(prev => [...prev, {id: makeId(24), uri: item.uri, base64: Platform.OS === "web" ? `data:image/jpg;base64,${item.base64}` : ''}]);
        })
      }
    } catch (e) {
      setIsPickImageError(true);
    }
  };

  const displayCameraActivityFailedAlert = async () => {
    await TaskManager.unregisterAllTasksAsync();
    await Updates.reloadAsync();
    setIsPickImageError(false);
  }; 

  const onRemoveImage = (data) => {
    let prev = [...imagesIds];
    let itemIndex = prev.indexOf(data[0]);
    if (itemIndex !== -1) {
      prev.splice(itemIndex, 1);
    } 
    setImagesIds([...prev]);

    let find = imagesArray.filter(item => item.id !== data[1]);
    setImagesArray(find);
  }

  const moveToFront = (data) => {
    var first0 = data[0];
    console.log(imagesIds, 1);
    let prev0 = [...imagesIds];
    prev0.sort(function(x,y){ return x == first0 ? -1 : y == first0 ? 1 : 0; });
    console.log(prev0, 2);
    setImagesIds([...prev0]);

    var first1 = data[1];
    let prev1 = [...imagesArray];
    prev1.sort(function(x,y){ return x["id"] == first1 ? -1 : y["id"] == first1 ? 1 : 0; });
    setImagesArray([...prev1]);
  }

  return (
    <View style={{ flexDirection: 'row', flexWrap: 'wrap', alignItems: 'center', gap: 20 }}>
      <TouchableOpacity onPress={pickImage}><Image style={{ width: 100, height: 100, borderRadius: 6 }} source={AddImage} /></TouchableOpacity>
      {
        imagesArray.map((item, i) => (
          <Uploader key={i} image={item} isUpload={isUpload} setImage={data => setImagesIds(prev => [...prev, data])} removeImage={data => onRemoveImage(data)} moveImageFirst={data => moveToFront(data)} />
        ))
      }
      <Portal>
        <Dialog visible={isPickImageError} onDismiss={() => setIsPickImageError(false)}>
          <Dialog.Title style={{ fontSize: 14, fontFamily: 'IRANSans_Medium', color: '#555' }}>مشکل در باز کردن گالری</Dialog.Title>
          <Dialog.Content>
            <Text variant="bodyMedium" style={{ fontSize: 12, fontFamily: 'IRANSans_Medium', color: '#666', fontFamily: 'IRANSans', textAlign: 'justify' }}>مشاور گرامی بدلیل اختلال در گوشی موبایل شما، اپلیکیشن در باز کردن گالری بمشکل خورده، لطفا دکمه ریستارت را برای اطلاح مشکل فشار دهید.</Text>
          </Dialog.Content>
          <Dialog.Actions>
            <Button onPress={() => setIsPickImageError(false)} labelStyle={{ color: '#555' }}>فعلا نه</Button>
            <Button onPress={() => displayCameraActivityFailedAlert()}>ریستارت</Button>
          </Dialog.Actions>
        </Dialog>
      </Portal>
    </View>
  );
};

const Uploader = ({image, isUpload:parentIsUpload, setImage, removeImage, moveImageFirst}) => {
  const refRBSheet = React.useRef();
  const [imageId, setImageId] = React.useState(image.id);
  const [isUpload, setIsUpload] = React.useState(false);
  const [isUploadError, setIsUploadError] = React.useState(false);
  const [uploadErrorText, setUploadErrorText] = React.useState([]);
  const [uploadProgress, setUploadProgress] = React.useState(0);

  React.useEffect(() => {
    if(parentIsUpload) {
      uploadImage(image);
    }
  }, [])

  React.useEffect(() => {
    if(imageId !== null) {
      setImage(imageId)
    }
  }, [imageId])

  const handlePresentModalPress = React.useCallback(() => {
    refRBSheet.current?.open();
  }, []);

  const DataURIToBlob = (dataURI, id) => {
    try {
      // جداسازی بخش‌های DataURI
      const splitDataURI = dataURI.split(',');
      
      // تشخیص نوع MIME از DataURI
      const mimeMatch = dataURI.match(/^data:(image\/\w+);base64,/);
      const mimeType = mimeMatch ? mimeMatch[1] : 'image/jpeg';
      
      // استخراج extension از MIME type
      const extension = mimeType.split('/')[1];
      
      // دیکد base64
      const byteString = atob(splitDataURI[1]);
      
      // ایجاد ArrayBuffer
      const arrayBuffer = new ArrayBuffer(byteString.length);
      const uint8Array = new Uint8Array(arrayBuffer);
      
      for (let i = 0; i < byteString.length; i++) {
        uint8Array[i] = byteString.charCodeAt(i);
      }
      
      // ایجاد Blob و سپس File
      const blob = new Blob([uint8Array], { type: mimeType });
      return new File([blob], `${id}.${extension}`, { type: mimeType });
    } catch (error) {
      console.error('Error converting DataURI:', error);
      return null;
    }
  }

  const uploadImage = async (image) => {
    setIsUpload(true);
    setIsUploadError(false);
    setUploadErrorText([]);
    
    try {
      let formData = new FormData();
      
      if (Platform.OS === "web") {
        // برای وب: تبدیل base64 به File
        const file = DataURIToBlob(image.base64, image.id);
        
        if (!file) {
          throw new Error('Failed to convert image to file');
        }
        
        formData.append('files', file);
      } else {
        // برای موبایل (iOS/Android)
        const filename = image.uri.split('/').pop();
        const match = filename.match(/\.(\w+)$/);
        const type = match ? `image/${match[1]}` : 'image/jpeg';
        
        // در React Native باید از این ساختار استفاده کرد
        formData.append('files', {
          uri: image.uri,
          name: filename || `image_${Date.now()}.jpg`,
          type: type,
        });
      }
      
      // 🔧 **افزودن اطلاعات اضافی برای دیباگ**
      console.log('FormData to send:', {
        hasImage: !!image,
        platform: Platform.OS,
        formDataKeys: Array.from(formData.keys())
      });
      
      // 🔧 **ارسال درخواست**
      const response = await axios.post('/upload_image', formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Accept": "application/json",
        },
        onUploadProgress: function(progressEvent) {
          if (progressEvent.total) {
            let percentCompleted = Math.floor(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            setUploadProgress(percentCompleted);
          }
        },
        timeout: 30000, // 30 ثانیه تایم‌اوت
      });
      
      console.log('Upload response:', response.data);
      setImageId(response.data);
      
    } catch (error) {
      console.error('Upload error details:', {
        error: error.message,
        response: error.response?.data,
        status: error.response?.status,
        headers: error.response?.headers
      });
      
      if (error.response?.data?.errors) {
        let text = [];
        Object.values(error.response.data.errors.files || {}).forEach((item) => {
          text.push(item);
        });
        setUploadErrorText(text.length > 0 ? text : ['خطا در آپلود تصویر']);
      } else if (error.response?.data?.message) {
        setUploadErrorText([error.response.data.message]);
      } else if (error.message) {
        setUploadErrorText([error.message]);
      } else {
        setUploadErrorText(['خطای ناشناخته در آپلود']);
      }
      
      setIsUploadError(true);
    } finally {
      setIsUpload(false);
      setUploadProgress(0);
    }
  };

  const onRemoveImage = () => {
    let id = imageId;
    removeImage([id, image.id]);
    refRBSheet.current?.close()
  }

  const onMoveImageFirst = () => {
    let id = imageId;
    moveImageFirst([id, image.id]);
    refRBSheet.current?.close()
  }

  return (
    <>
      <TouchableOpacity onPress={handlePresentModalPress} style={{ width: 100, height: 100, borderWidth: isUploadError ? 1 : 0, borderColor: '#f00', borderRadius: 6, overflow: 'hidden' }}>
        {
          isUpload ?
            <View style={{ width: 100, height: 100, backgroundColor: 'rgba(0, 0, 0, 0.3)', position: 'absolute', top: 0, right: 0, justifyContent: 'center', alignItems: 'center', paddingHorizontal: 8, zIndex: 2 }}>
               <View style={{ width: `${uploadProgress}%`, height: 2, backgroundColor: '#fff', borderRadius: 2 }} />
            </View>
          :
            isUploadError &&
              <View style={{ width: 100, height: 100, backgroundColor: 'rgba(0, 0, 0, 0.3)', position: 'absolute', top: 0, right: 0, justifyContent: 'center', alignItems: 'center', paddingHorizontal: 8, zIndex: 2 }}>
                <Text style={{ fontSize: 8, color: '#fff', textAlign: 'center', lineHeight: 18 }}>{uploadErrorText.join(', ')}</Text>
              </View>
        }
        <Image style={{ width: '100%', height: '100%' }} resizeMode='cover' source={{ uri: image.uri }} />
      </TouchableOpacity>
      <RBSheet
        ref={refRBSheet}
        closeOnDragDown={true}
        closeOnPressMask={true}
        height={160}
        customStyles={{
          wrapper: {
            backgroundColor: "rgba(0, 0, 0, 0.3)"
          },
          draggableIcon: {
            backgroundColor: "#555"
          }
        }}
      >
        <View style={{ paddingHorizontal: 20, paddingVertical: 12 }}>
          <Button mode="contained" style={{ width: '100%', marginBottom: 8, borderRadius: 48 }} contentStyle={{ height: 48, paddingTop: 5 }} labelStyle={{ fontFamily: 'IRANSans_Medium', fontSize: 16 }} onPress={onMoveImageFirst}>تنظیم بعنوان تصویر اول</Button>
          <Button mode="outlined" style={{ width: '100%', marginBottom: 8, borderRadius: 48 }} contentStyle={{ height: 48, paddingTop: 5 }} labelStyle={{ fontFamily: 'IRANSans_Medium', fontSize: 16 }} onPress={onRemoveImage}>حذف تصویر</Button>
        </View>
      </RBSheet>
    </>
  );
}